import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class OcorrenciaValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;
        
        if (refs.idagro_ocorrenciaerpInput.required && Util.isNull(model.idagro_ocorrenciaerp)) {
			refs.idagro_ocorrenciaerpInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.idagro_tipoocorrencia)) {
			refs.tipoSelect.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.nomepopular )) {
			refs.nomepopularInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.nomecientifico)) {
			refs.nomecientificoInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.identificar)) {
			refs.identificarField.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.perdas)) {
			refs.perdasField.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.manejo)) {
			refs.manejoField.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.controlar)) {
			refs.controlarField.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}